import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchLeads,
  updateLeadField,
  type OnboardingUser,
} from '../../services/leads-api';

export const LEADS_QUERY_KEY = ['leads'];

export function useLeads() {
  return useQuery({
    queryKey: LEADS_QUERY_KEY,
    queryFn: fetchLeads,
  });
}

export function useUpdateLead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      field,
      value,
    }: {
      id: string;
      field: string;
      value: string;
    }) => {
      await updateLeadField(id, field, value);
      return { id, field, value };
    },
    onSuccess: ({ id, field, value }) => {
      // Update the cache optimistically
      queryClient.setQueryData(
        LEADS_QUERY_KEY,
        (old: OnboardingUser[] | undefined) => {
          if (!old) return old;
          return old.map(lead =>
            lead.id === id ? { ...lead, [field]: value } : lead
          );
        }
      );
    },
  });
}

export function useRefreshLeads() {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: LEADS_QUERY_KEY });
  };
}
